import { render, staticRenderFns } from "./salesStatistics.vue?vue&type=template&id=765e815d&scoped=true"
import script from "./salesStatistics.vue?vue&type=script&lang=js"
export * from "./salesStatistics.vue?vue&type=script&lang=js"
import style0 from "./salesStatistics.vue?vue&type=style&index=0&id=765e815d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765e815d",
  null
  
)

export default component.exports